module.exports = __webpack_public_path__ + "img/valencia1.f1ed0c4e.jpg";